<template>
  <div>
    <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
      :height="150"
      :width="150"
      :color="'#FFFF00'"
      :background-color="'#000000'"
      :opacity="0.5"
    ></loading>
    <v-container>
      <v-form>
        <v-row>
          <h2 class="pb-5">
            {{ this.parentObject.pageTitle
            }}<span class="page_title_value">{{
              this.parentObject.pageTitleValue
            }}</span>
          </h2>
        </v-row>

        <v-col class="mt-n4 mb-2">
          <v-row>
            <v-btn
              v-model="goBtn"
              @click="backButton()"
              color="orange"
              class="white--text"
              >{{$t('button.back')}}</v-btn
            >
          </v-row>
        </v-col>

        <!-- <v-container
          id="scroll-target"
          class="custom-form overflow-y-auto px-5"
        > -->
         <v-container style="overflow-x: hidden; max-width: 100%">
          <v-row>
            <v-toolbar flat>
              <v-toolbar-title
                >{{$t('attendancereportbypeiordbycompanyreport.attendancereportfrom')}}
                <span class="blue--text">
                    {{ this.data.formData.asofdate1 }}</span
                  >
                  {{$t('columns.to')}}
                  <span class="blue--text">
                    {{ this.data.formData.asofdate2 }}</span
                  > {{$t('attendancereportbypeiordbycompanyreport.for')}}
                   <span class="blue--text">
                    {{ this.data.formData.compnycode }}</span
                  > 
              </v-toolbar-title>
              <v-spacer></v-spacer>

                <div class="export-icon-btns">
                            <button type="button" class="export-icon-btn export-icon-pdf" @click="printPDF" title="Export PDF">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2a2 2 0 0 1 0 4H9v-4z"/><path d="M15 13h1a2 2 0 0 1 0 4h-1"/><line x1="15" y1="17" x2="17" y2="17"/></svg>
                              PDF
                            </button>
                            <button type="button" class="export-icon-btn export-icon-csv" @click="getCSV" title="Export CSV">
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
                              CSV
                            </button>
                          </div>

              <div class="gv-search" style="align-self: center; margin-left: 8px;">
                <svg class="gv-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input v-model="search" type="text" placeholder="Search..." class="gv-search-input" />
              </div>
          </v-toolbar>
        </v-row>

        <v-row class="pb-5" font-size = "5px">
              <v-toolbar-title>

                {{$t('attendancereportbypeiordbycompanyreport.filterby')}}
                   <span class="blue--text">
                     <v-div
                      v-if="this.data.parameters.staffid"
                     > {{this.data.parameters.staffcode}}, </v-div>
                     
                     <v-div
                      v-if="this.data.parameters.deptid"
                     > {{this.data.parameters.deptname}}, </v-div>

                     <v-div
                      v-if="this.data.parameters.brchid"
                     > {{this.data.parameters.brchname}}, </v-div>

                     <v-div
                      v-if="this.data.parameters.sectioid"
                     > {{this.data.parameters.sectioname}}, </v-div>

                     <v-div
                      v-if="this.data.parameters.unitid"
                     > {{this.data.parameters.unitname}}, </v-div>

                    <v-div
                      v-if ="this.data.parameters.divnid"
                     > {{this.data.parameters.divnname}} </v-div>

                    <v-div
                      v-if="this.data.parameters.workgroupid"
                    > {{this.data.parameters.valuedesc}}, </v-div>

                  </span>   
                                
              </v-toolbar-title>
              
              <v-spacer></v-spacer>
              </v-row>

          <v-row>
            <v-col cols="12" style="max-width: 100%;">
              <v-data-table
                :headers="dataHeader"
                :search="search"
                :items="dataItems"
                :items-per-page="25"
                :footer-props="{ 'items-per-page-options': [10, 25, 50, 100, -1] }"
                class="font-weight-light;text--secondary; attendance-table"
                :sort-by="['code']"
                fixed-header
                height="calc(100vh - 320px)"
                no-data-text="No records found."
              >
              </v-data-table>
            </v-col>
          </v-row>

       
        </v-container>
      </v-form>
   </v-container>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: {
    parentObject: Object,
  },

  components: {
  //  "app-error": ErrorDialog,
    Loading,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      rules: {
        required: (value) => !!value || this.$t('reportsparam.required'),
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
        },
      },

      data: {
        formData: {
           asofdate1: this.$route.params.formData.asofdate1,
           asofdate2: this.$route.params.formData.asofdate2,
           compnyid : this.$route.params.formData.compnyid,
           compnycode: this.$route.params.formData.compnycode,
           latecomeronly: this.$route.params.formData.latecomeronly,
           earlygoeronly: this.$route.params.formData.earlygoeronly,
           absenteeism: this.$route.params.formData.absenteeism,
           incompleteonly: this.$route.params.formData.incompleteonly,
         //  userid: this.$store.getters.userId,
        },

       parameters: {
           brchid: this.$route.params.param.branchid,
           brchname: this.$route.params.param.brchname,
           deptid: this.$route.params.param.departmentid,
           deptname: this.$route.params.param.deptname,
           sectioid: this.$route.params.param.sectionid,
           sectioname: this.$route.params.param.sectioname,
           unitid: this.$route.params.param.unitid,
           unitname: this.$route.params.param.unitname,
           workgroupid: this.$route.params.param.workgroupid,
           valuedesc: this.$route.params.param.valuedesc2,
           divnid: this.$route.params.param.divisionid,
           divnname: this.$route.params.param.divnname,
           staffid: this.$route.params.param.staffid,
           staffcode: this.$route.params.param.staffcode,
   
         },
      },

      dataHeader: [
        { text: this.$t('statutoryexportcommonused.no'),  width:'84', value: 'id'},
        { text: this.$t('columns.date'), width:'120', value: 'shiftdate'},
        { text: this.$t('attendancereportbypeiordbycompanyreport.staffcode'), width:'84', value: "staffcode"},
        { text: this.$t('columns.name'), width:'140', value: "psnname"},
        { text: this.$t('setuprestdaypatternsetup.daytype'), value: "daytypecode"},
        { text: this.$t('staffdailyrosterrecord.shift'), value: "shiftcode" },
        { text: this.$t('attendancereportbypeiordbycompanyreport.shifttype'), width:'140', value: "shiftdesc" },
        { text: this.$t('attendancereportbypeiordbycompanyreport.shiftstarttime'), value: "starttime" },
        { text: this.$t('attendancereportbypeiordbycompanyreport.shiftendtime'), value: "endtime" },
        { text: this.$t('processedattendancedatarecord.intime'), value: "intime" },
        { text: this.$t('processedattendancedatarecord.outtime'), value: "outtime" },
        { text: this.$t('processedattendancedatarecord.workhours'), value: "workhrs" },
        { text: this.$t('attendancereportbypeiordbycompanyreport.workhourspay'), value: "workhrspay" },
        { text: this.$t('setupforshift.othours'), value: "othrs" },
        { text: this.$t('attendancereportbypeiordbycompanyreport.othourspay'), value: "othrspay" },
        { text: this.$t('columns.leavecode'), value: "leavecode" },
        { text: this.$t('setupforshift.shiftallowance'), value: "sftallwpayitemcodes" },
        { text: this.$t('attendancereportbypeiordbycompanyreport.otallowancecode'), width:'140', value: "otallwpayitemcodes" },
    
      ],

      tableOpt: {
        itemsPerPage: -1,
      },

      search: '',
      dataItems: [],
      dataHolder: [],
      dataHolder4: [],
      dataHolder3: [],
      dataHolder2: [],
      branch: [],
      branchList: [],
      units: [],
      unitList: [],
      divisions: [],
      divisionList: [],
      sections: [],
      sectionList: [],
      workgroup: [],
      workgroupList: [],
      staff: [],
      staffList: [],
      department: [],
      departmentList: [],

      goBtn: false,
      loading: false,
    };
  },

  methods: {
    normalizeAllowanceFields(item) {
      if (!item) {
        return item;
      }

      item.sftallwpayitemcodes =
        item.sftallwpayitemcodes || item.sftallwpayitemcode || "";
      item.otallwpayitemcodes =
        item.otallwpayitemcodes || item.otallwpayitemcode || "";

      return item;
    },
    backButton() {
      this.$router.push({ name: "attendanceperiod" });
    },


    loadReport(){

      const vm = this;

      this.goBtn = true;
      vm.loading = true;

      // vm.dataItems = res.data.rec;

            // for(let i = 0; i < vm.dataItems.length; i++){
            //    vm.dataItems[i].id = i + 1;

      if (this.formData.latecomeronly == true) {
        
        this.loadAttendanceLateComer();
      }      

     if (this.formData.earlygoeronly == true) {
        this.loadAttendanceEarlyGoer();
      } 
      
     if (this.formData.absenteeism == true) {
        this.loadAttendanceAbsent();
      } 
      
     if (this.formData.incompleteonly == true) { 
         this.loadAttendanceIncomplete();
      } 
      
      if(this.formData.latecomeronly == false && this.formData.earlygoeronly == false 
      && this.formData.absenteeism == false && this.formData.incompleteonly == false ){
        this.loadAttendancePeriod();
       }   


       //vm.dataItems = res.data.rec;

      //   for(let i = 0; i < vm.dataItems.length; i++){
      //       vm.dataItems[i].id = i + 1;        
      // }

      // console.log('dataitem', vm.dataItems)

    },

    loadAttendancePeriod(){

    //  this.goBtn = true;
            
      const vm = this;

      this.$store.dispatch('post', {
          url: `/attendanceperiod/${this.$store.getters.userId}`,
          payload: vm.data
        })
          .then(res => {
            vm.loading = false;

            vm.dataItems = res.data.rec;

            for(let i = 0; i < vm.dataItems.length; i++){
               vm.dataItems[i].id = i + 1;
               vm.dataItems[i].shiftdate = moment(vm.dataItems[i].shiftdate).format("DD-MM-YYYY");
              vm.normalizeAllowanceFields(vm.dataItems[i]);

              if (vm.dataItems[i].intime != null) {
                vm.dataItems[i].intime = moment(vm.dataItems[i].intime).format("HH:mm:ss");
               }

              if (vm.dataItems[i].outtime != null) {
                vm.dataItems[i].outtime = moment(vm.dataItems[i].outtime).format("HH:mm:ss");
               } 
            }
          })
     },

     loadAttendanceLateComer(){           
      const vm = this;

      this.$store.dispatch('post', {
          url: `/attendancelatecomer/${this.$store.getters.userId}`,
          payload: vm.data
        })
          .then(res => {
            vm.loading = false;

            vm.dataHolder = res.data.rec 
            let a = 0

            for(let i = 0; i < vm.dataHolder.length; i++){

            //  vm.dataHolder[i].id = i+1;
              vm.dataHolder[i].shiftdate = moment(vm.dataHolder[i].shiftdate).format("DD-MM-YYYY");
            
            if (vm.dataItems.length > 0 && i== 0) {

                a = vm.dataItems.length + 1
            } else {
              a++
            }

            vm.dataHolder[i].id = a;
            vm.normalizeAllowanceFields(vm.dataHolder[i]);

            vm.dataItems.push(vm.dataHolder[i])
              
            }
          })
     },

     loadAttendanceEarlyGoer(){
           
      const vm = this;

      this.$store.dispatch('post', {
          url: `/attendanceearlygoer/${this.$store.getters.userId}`,
          payload: vm.data
        })
          .then(res => {
            vm.loading = false;

            vm.dataHolder4 = res.data.rec 

               let a = 0

              for(let i = 0; i < vm.dataHolder4.length; i++){
              
               //vm.dataHolder4[i].id = i + 1; 
               vm.dataHolder4[i].shiftdate = moment(vm.dataHolder4[i].shiftdate).format("DD-MM-YYYY");

                
              if (vm.dataItems.length > 0 && i== 0) {

                  a = vm.dataItems.length + 1
              } else {
                a++
              }

              vm.dataHolder4[i].id = a;
                vm.normalizeAllowanceFields(vm.dataHolder4[i]);


               vm.dataItems.push(vm.dataHolder4[i])             
            }
          })
     },

     loadAttendanceAbsent(){
            
      const vm = this;

      this.$store.dispatch('post', {
          url: `/attendanceabsent/${this.$store.getters.userId}`,
          payload: vm.data
        })
          .then(res => {
            vm.loading = false;

            vm.dataHolder3 = res.data.rec 
              let a = 0

            for(let i = 0; i < vm.dataHolder3.length; i++){

            //  vm.dataHolder3[i].id = i + 1; 
              vm.dataHolder3[i].shiftdate = moment(vm.dataHolder3[i].shiftdate).format("DD-MM-YYYY");

              if (vm.dataItems.length > 0 && i== 0) {

                  a = vm.dataItems.length + 1
              } else {
                a++
              }

              vm.dataHolder3[i].id = a;
              vm.normalizeAllowanceFields(vm.dataHolder3[i]);

              vm.dataItems.push(vm.dataHolder3[i])
            }
          })
     },

     loadAttendanceIncomplete(){
            
      const vm = this;

      this.$store.dispatch('post', {
          url: `/attendanceincomplete/${this.$store.getters.userId}`,
          payload: vm.data
        })
          .then(res => {
            vm.loading = false;

            vm.dataHolder2 = res.data.rec 

            let a = 0

            for(let i = 0; i < vm.dataHolder2.length; i++){

            //  vm.dataHolder2[i].id = i + 1; 
              vm.dataHolder2[i].shiftdate = moment(vm.dataHolder2[i].shiftdate).format("DD-MM-YYYY");

              if (vm.dataItems.length > 0 && i== 0) {

                  a = vm.dataItems.length + 1
              } else {
                a++
              }

              vm.dataHolder2[i].id = a;
              vm.normalizeAllowanceFields(vm.dataHolder2[i]);

              vm.dataItems.push(vm.dataHolder2[i])
             
             }
          })
     },

 loadStaffListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: `/staff/all/${this.$store.getters.userId}`
        })
        .then((res) => {
          vm.staff = res.data.rec;
    
          for (let i = 0; i < vm.staff.length; i++) {
            vm.staffList.push({
              text: vm.staff[i].staffcode + " " + vm.staff[i].psnname + " " + vm.staff[i].compnyname,
              value: vm.staff[i].id,
            });
            if (vm.data.parameters.staffid) {
                this.ChangeStaffHandler(vm.data.parameters.staffid);

           }
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

     ChangeStaffHandler(id){

       let item = this.staff.find((item) => item.id === id);
       this.data.parameters.staffid = item.id;
       this.data.parameters.staffcode = item.staffcode;

    },

    loadBranchListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: '/branch/all'
        })
        .then((res) => {
          vm.branch = res.data.rec;

          for (let i = 0; i < vm.branch.length; i++) {
            vm.branchList.push({
              text: vm.branch[i].brchname,
              value: vm.branch[i].id,
            });

           if (vm.data.parameters.brchid) {
                this.ChangeBranchHandler(vm.data.parameters.brchid);
           }
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    ChangeBranchHandler(id){

       let item = this.branch.find((item) => item.id === id);
       this.data.parameters.brchid = item.id;
       this.data.parameters.brchname = item.brchname;

    },

      loadDepartmentListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: '/department/all'
        })
        .then((res) => {
          vm.department = res.data.rec;

          for (let i = 0; i < vm.department.length; i++) {
            vm.departmentList.push({
              text: vm.department[i].deptname,
              value: vm.department[i].id,
            });
            if (vm.data.parameters.deptid) {
                this.ChangeDepartmentHandler(vm.data.parameters.deptid);
           }
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

     ChangeDepartmentHandler(id){

       let item = this.department.find((item) => item.id === id);
       this.data.parameters.deptid = item.id;
       this.data.parameters.deptname = item.deptname;

    },


     //load units
    loadUnitListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: '/unit/all'
        })
        .then((res) => {
          vm.units = res.data.rec;

          for (let i = 0; i < vm.units.length; i++) {
            vm.unitList.push({
              text: res.data.rec[i].unitname,
              value: res.data.rec[i].id,
            });
            if (vm.data.parameters.unitid) {
                this.ChangeUnitHandler(vm.data.parameters.unitid);

           }
          }
        })
        .catch((err) => {
          //error - unsucessfull request
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

     ChangeUnitHandler(id){

       let item = this.units.find((item) => item.id === id);
       this.data.parameters.unitid = item.id;
       this.data.parameters.unitname = item.unitname;
    },

    //load section
    loadSectionListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: '/section/all'
        })
        .then((res) => {
          vm.sections = res.data.rec;
          for (let i = 0; i < vm.sections.length; i++) {
            vm.sectionList.push({
              text: res.data.rec[i].sectioname,
              value: res.data.rec[i].id,
            });
            if (vm.data.parameters.sectioid) {
                this.ChangeSectionHandler(vm.data.parameters.sectioid);
           }
          }
        })
        .catch((err) => {
          //error - unsucessfull request
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

     ChangeSectionHandler(id){

       let item = this.sections.find((item) => item.id === id);
       this.data.parameters.sectioid = item.id;
       this.data.parameters.sectioname = item.sectioname;
    },

    
    //load divisions
    loadDivisionListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: '/division/all'
        })
        .then((res) => {
          vm.divisions = res.data.rec;
          for (let i = 0; i < vm.divisions.length; i++) {
            vm.divisionList.push({
              text: res.data.rec[i].divnname,
              value: res.data.rec[i].id,
            });
            if (vm.data.parameters.divnid) {
                this.ChangeDivisionHandler(vm.data.parameters.divnid);
           }
          }
        })
        .catch((err) => {
          //error - unsucessfull request
          vm.isErr = true;
          vm.errMsg = err;
          vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
        });
    },

     ChangeDivisionHandler(id){

       let item = this.divisions.find((item) => item.id === id);
       this.data.parameters.divnid = item.id;
       this.data.parameters.divnname = item.divnname;
    },

    loadWorkGroupListHandler() {
      const vm = this;

      this.$store.dispatch('get', {
          url: '/groupp_grouppb_workday/all'
        })
        .then((res) => {
          vm.workgroup = res.data.rec;

          for (let i = 0; i < vm.workgroup.length; i++) {
            vm.workgroupList.push({
              text: vm.workgroup[i].valuedesc,
              value: vm.workgroup[i].valvalueid,
            });
             if (vm.data.parameters.workgroupid) {
                this.ChangeWorkGroupHandler(vm.data.parameters.workgroupid);
           }
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

     ChangeWorkGroupHandler(valvalueid){

       let item = this.workgroup.find((item) => item.valvalueid === valvalueid);
       this.data.parameters.workgroupid = item.valvalueid;
       this.data.parameters.valuedesc = item.valuedesc;
    },

    printPDF() {
       const doc = new jsPDF({
         orientation: "landscape",
       });

      var head = [
        { title: this.$t('statutoryexportcommonused.no'),  dataKey: 'id'},
        { title: this.$t('columns.date'),  dataKey: 'shiftdate'},
        { title: this.$t('attendancereportbypeiordbycompanyreport.staffcode'), dataKey: "staffcode"},
        { title: this.$t('columns.name'), dataKey: "psnname"},
        { title: this.$t('setuprestdaypatternsetup.daytype'), dataKey: "daytypecode"},
        { title: this.$t('staffdailyrosterrecord.shift'), dataKey: "shiftcode" },
        { title: this.$t('attendancereportbypeiordbycompanyreport.shifttype'), dataKey: "shiftdesc" },
        { title: this.$t('attendancereportbypeiordbycompanyreport.shiftstarttime'), dataKey: "starttime" },
        { title: this.$t('attendancereportbypeiordbycompanyreport.shiftendtime'), dataKey: "endtime" },
        { title: this.$t('processedattendancedatarecord.intime'), dataKey: "intime" },
        { title: this.$t('processedattendancedatarecord.outtime'), dataKey: "outtime" },
        { title: this.$t('processedattendancedatarecord.workhours'), dataKey: "workhrs" },
        { title: this.$t('attendancereportbypeiordbycompanyreport.workhourspay'), dataKey: "workhrspay" },
        { title: this.$t('setupforshift.othours'), dataKey: "othrs" },
        { title: this.$t('attendancereportbypeiordbycompanyreport.othourspay'), dataKey: "othrspay" },
        { title: this.$t('columns.leavecode'), dataKey: "leavecode" },
        { title: this.$t('setupforshift.shiftallowance'), dataKey: "sftallwpayitemcodes" },
        { title: this.$t('attendancereportbypeiordbycompanyreport.otallowancecode'), dataKey: "otallwpayitemcodes" },
       ];

       let body = [];
        for (var i = 0; i < this.dataItems.length; i++) {
        body.push({
          id: this.dataItems[i].id,
          shiftdate: this.dataItems[i].shiftdate,
          staffcode : this.dataItems[i].staffcode,
          psnname: this.dataItems[i].psnname,
          daytypecode: this.dataItems[i].daytypecode,
          shiftcode: this.dataItems[i].shiftcode,
          shiftdesc: this.dataItems[i].shiftdesc,
          starttime: this.dataItems[i].starttime,
          endtime: this.dataItems[i].endtime,
          intime: this.dataItems[i].intime,
          outtime: this.dataItems[i].outtime,
          workhrs: this.dataItems[i].workhrs,
          workhrspay: this.dataItems[i].workhrspay,
          othrs: this.dataItems[i].othrs,
          othrspay: this.dataItems[i].othrspay,
          leavecode: this.dataItems[i].leavecode,
          sftallwpayitemcodes: this.dataItems[i].sftallwpayitemcodes,
          otallwpayitemcodes: this.dataItems[i].otallwpayitemcodes,
        });
      }
         doc.text(
        `Attendance Report from ${this.formData.asofdate1} to ${this.formData.asofdate2} for ${this.formData.compnycode}`,
        10,
        10
      );
 
      doc.autoTable(head, body);
      doc.save("Attendance Report " + "-" + this.formData.compnycode + ".pdf");
    },

    objectToCSV(data) {
      const csvRows = [];

      // get header
      const headers = Object.keys(data[0]);
      csvRows.push(headers.join(","));

      // loop over the rows
      for (const row of data) {
        const values = headers.map((header) => {
          const escaped = ("" + row[header]).replace(/"/g, '\\"');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(","));
      }
      return csvRows.join("\n");
    },

    download(data) {
      const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.setAttribute("hidden", "");
      a.setAttribute("href", url);
      a.setAttribute(
        "download",
        "Attendance Report " + "-" + this.formData.compnycode + ".csv"
      );

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },

    async getCSV() {
      let item = this.dataItems;
      let data = [];

      for (var i = 0; i < item.length; i++) {
        data.push({
        [`${this.$t('statutoryexportcommonused.no')}`]: item[i].id,
        [`${this.$t('columns.date')}`]: item[i].shiftdate,
        [`${this.$t('attendancereportbypeiordbycompanyreport.staffcode')}`]: item[i].staffcode,
        [`${this.$t('columns.name')}`]: item[i].psnname,
        [`${this.$t('setuprestdaypatternsetup.daytype')}`]: item[i].daytypecode,
        [`${this.$t('staffdailyrosterrecord.shift')}`]: item[i].shiftcode,
        [`${this.$t('attendancereportbypeiordbycompanyreport.shifttype')}`]: item[i].shiftdesc,
        [`${this.$t('attendancereportbypeiordbycompanyreport.shiftstarttime')}`]: item[i].starttime,
        [`${this.$t('attendancereportbypeiordbycompanyreport.shiftendtime')}`]: item[i].endtime,
        [`${this.$t('processedattendancedatarecord.intime')}`]: item[i].intime,
        [`${this.$t('processedattendancedatarecord.outtime')}`]: item[i].outtime,
        [`${this.$t('processedattendancedatarecord.workhours')}`]: item[i].workhrs,
        [`${this.$t('attendancereportbypeiordbycompanyreport.workhourspay')}`]: item[i].workhrspay,
        [`${this.$t('setupforshift.othours')}`]: item[i].othrs,
        [`${this.$t('attendancereportbypeiordbycompanyreport.othourspay')}`]: item[i].othrspay,
        [`${this.$t('columns.leavecode')}`]: item[i].leavecode,
        [`${this.$t('setupforshift.shiftallowance')}`]: item[i].sftallwpayitemcodes || item[i].sftallwpayitemcode,
        [`${this.$t('attendancereportbypeiordbycompanyreport.otallowancecode')}`]: item[i].otallwpayitemcodes || item[i].otallwpayitemcode,
        });
      }

      const csvData = this.objectToCSV(data);
      this.download(csvData);
    },

},


  mounted() {},

  created() {
    const vm = this;
    vm.formData = this.$route.params.formData;

    this.loadReport();
    this.loadBranchListHandler();
    this.loadDepartmentListHandler();
    this.loadDivisionListHandler();
    this.loadUnitListHandler();
    this.loadSectionListHandler();
    this.loadStaffListHandler();
    this.loadWorkGroupListHandler();

  
  },
};
</script>

<style>
.dateTitle {
  font-size: 12px;
  color: #ffffff;
  height: 0px;
  background-color: orange;
  align-content: center;
  justify-content: center;
}

.scroller {
  height: 100%;
  width: 100%;
}

/* Table scrolls horizontally; toolbar and pagination stay pinned */
.attendance-table {
  width: 100%;
}

/* Force the inner table to be wide enough to need horizontal scrolling
   — the v-data-table__wrapper handles the scroll, not the page */
.attendance-table .v-data-table__wrapper table {
  min-width: 1400px;
}

/* Ensure the sticky header z-index is above table rows */
.attendance-table thead tr th {
  position: sticky !important;
  top: 0 !important;
  z-index: 2 !important;
}

.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-pdf { background: #FEF2F2; color: #DC2626; border: 1px solid #FECACA; }
.export-icon-pdf:hover { background: #DC2626; color: #fff; border-color: #DC2626; }
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; border-color: #059669; }

.gv-search { position: relative; display: inline-flex; align-items: center; }
.gv-search-icon { position: absolute; left: 8px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.gv-search-input { padding: 5px 10px 5px 30px; border: 1.5px solid #E8EDF5; border-radius: 8px; font-size: 0.83rem; font-family: inherit; color: #1E293B; outline: none; width: 200px; background: #fff; }
.gv-search-input:focus { border-color: #4F6BFF; box-shadow: 0 0 0 3px rgba(79,107,255,0.10); }
</style>